import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { array, func, object } from 'prop-types';
import cn from 'classnames';

import { DesktopAndTablet } from '../../../utils/responsiveQueries';
import { ReactComponent as SdksIcon } from '../../../styles/icon/menu/sdks.svg';
import { loadSdkContent } from '../../../redux/reducers/ghost';
import SdkPage from './SdkPage';
import docs from '../CombinedDocs.module.scss';

const mapStateToProps = (state) => ({
  ghostSdkPages: state.ghost.sdkPages,
  location: state.router.location,
});
const mapDispatchToProps = {
  loadSdkContent
};

SdkNavigation.propTypes = {
  ghostSdkPages: array,
  loadSdkContent: func,
  preventClosingMenu: func,
  location: object
};

SdkNavigation.defaultProps = {
  ghostSdkPages: []
}

function SdkNavigation(props) {
  const [isSdkClick, clickHandler] = useState(false);
  const { ghostSdkPages, loadSdkContent, preventClosingMenu, location } = props;

  useEffect(() => {
    if (location.pathname.indexOf('/docs/sdks') === -1) {
      clickHandler(false);
    }
  }, [location]);

  if (!ghostSdkPages.length) return null;

  return (
    <div className={docs.docs__block}>
      <DesktopAndTablet>
        <div className={cn(docs.docs__title_wrapper, docs.docs__sdk)}>
          <span><SdksIcon /></span>
          <h4 className={docs.docs__menu_title}>sdks</h4>
        </div>
      </DesktopAndTablet>
      <div
        className={docs.docs__list}
        onClick={() => clickHandler(true)}
      >
        {!!ghostSdkPages.length && (
          ghostSdkPages.map((c, i) => (
            <SdkPage
              key={i}
              data={c}
              loadSdkContent={loadSdkContent}
              preventClosingMenu={preventClosingMenu}
              isSdkClick={isSdkClick}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SdkNavigation);
